"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.sourceType.group': 'Gruppo',
    'whatsapp.sourceType.dm': 'DM',
    'whatsapp.sourceType.email': 'Email',
};
